<template>
  <div class="d-flex flex-column align-items-center">
    <div class='main-content' v-if="loaded">
      <!-- <content-header title="Player Registration" /> -->
      <el-steps :active="step" align-center finish-status="success" class="d-flex justify-content-center">
        <el-step v-show="!registration.isBulk" title="Member Details"></el-step>
        <el-step v-show="hasAdditionalQs > 0" title="Additional Questions"></el-step>
        <el-step v-show="hasSubProducts " title="Sub Product Selection"></el-step>
        <el-step v-show="hasSaleableItems" title="Store"></el-step>
        <el-step title="Payment"></el-step>
      </el-steps>
      <content-body-card>
        <!-- <family-details v-if="step === 0 && msProductType === 'family'" :membership="selectedMembership" @update-step="updateStep" @tc-update="updateButtonStatus" ref="rego"/> -->
        <div v-if="step === 0 && msProductType === 'family'"  :key="key">
          <div v-if="!editingRego">
            <player-details v-for="(f, i) in selectedMembership.familyRego" :key="i" @forceRefresh="forceRefresh" :editing="editing" :editingRego="editingRego" :requiresApproval="selectedMembership.requiresApproval" :memberId="f.memberId" :membership="f" @updateFamilyMs="updateFamilyMs"  @validateFamilyDetail="validateFamilyDetail" @update-step="updateStep" @tc-update="updateButtonStatus" ref="familyRef"/>
          </div>
          <div v-else>
            <player-details v-for="(f, i) in editingRego.familyRegistrations" :key="i" @forceRefresh="forceRefresh" :editing="editing" :editingRego="editingRego" :requiresApproval="editingRego.requiresApproval" :memberId="f.memberId" :membership="f" @updateFamilyMs="updateFamilyMs"  @validateFamilyDetail="validateFamilyDetail" @update-step="updateStep" @tc-update="updateButtonStatus" ref="familyRef"/>
          </div>
        </div>
        <player-details v-if="step === 0 && msProductType !== 'family' && !registration.isBulk" :memberId="memberId" :editing="editing" :membership="selectedMembership" :requiresApproval="requiresApproval" :editingRego="editingRego" @update-step="updateStep" @tc-update="updateButtonStatus" ref="rego"/>
        <additional-questions v-if="step === 1" :editing="editing" :value="registration" @update-step="updateStep" ref="rego"/>
        <sub-products v-if="step === 2 && hasSubProducts " :editing="editing" :value="registration" @update-step="updateStep" ref="rego"/>
        <store v-if="step === 3 && hasSaleableItems" :editing="editing" :value="registration" @update-step="updateStep" ref="rego" @update-store="updateButtonStatus"/>
        <el-row class="mt-10">
          <el-divider></el-divider>
          <el-row :span="24" class="d-flex mt-10" :gutter="20">
            <el-col :span="12" class="d-flex justify-content-end">
              <el-button class="bottomBtn" @click="back">Back</el-button>
            </el-col>
            <el-col :span="12">
              <el-button type="primary" :class="isNextDisabled ? 'bottomBtn disabled-next' : 'btn-highlight bottomBtn'" @click.prevent="next" :disabled="isNextDisabled">
                Next
              </el-button>
            </el-col>
          </el-row>
        </el-row>
      </content-body-card>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';

import moment from 'moment-timezone';
import { calculateMemberAge } from '@/utils/helpers';
import PlayerDetails from './1-PlayerDetails.vue';
import AdditionalQuestions from './2-AdditionalQuestions.vue';
import SubProducts from './3-SubProducts.vue';

import Store from './4-Store.vue';

export default {
  name: 'RegisterIndividual',
  components: {
    PlayerDetails,
    AdditionalQuestions,
    Store,
    SubProducts
  },
  props: {
    criteria: {
      type: String,
      default: ''
    },
    memberId: Number,
    selectedMembership: Object,
    upgradeFromMembership: Object,
    member: Object,
    editing: Boolean,
    editingRego: Object
  },
  data() {
    return {
      step: 0,
      registration: {
        entityType: undefined,
        entityId: undefined,
        memberId: undefined,
        profile: undefined,
        productType: undefined,
        memberType: undefined,
        product: undefined,
        additionalQs: undefined,
        saleableItems: undefined,
        subProducts: undefined,

        discounts: undefined,
        acceptActiveKids: undefined,
        meta: undefined,
        tags: undefined,
        isClubMembership: undefined,
        isRenewable: undefined,
        orgtree: undefined,
      },
      familyRegistrations: [],
      familyRef: [],
      isNextDisabled: true,
      key: 0,
      selectedRego: undefined,
      memberID: undefined,
      loaded: false,
      isRequiredRego: false,
      isTCAccepted: false,
      requiresApproval: false
    };
  },
  mounted() {
    console.log('memberId', this.memberId, 'selectedMembership', this.selectedMembership, 'member', this.member);
    console.log('editingRego', this.editingRego);
    if (this.selectedMembership) {
      this.requiresApproval = this.selectedMembership.requiresApproval;
    } else if (this.editingRego) {
      this.requiresApproval = this.editingRego.requiresApproval;
    }
    this.loaded = true;
  },
  methods: {
    forceRefresh() {
      this.key++;
      this.familyRegistrations = [];
      this.familyRef = [];
    },
    updateButtonStatus(status) {
      console.log('status', status);
      this.isNextDisabled = status;
      this.isTCAccepted = !status;
    },
    async updateStep(val, step = 1) {
      _.assign(this.registration, val);
      console.log(`doing step ${step}`);
      console.log('this.step', this.step);
      console.log('val.isTCRequired', val);
      console.log('this.isTCAccepted', this.isTCAccepted);
      console.log('this.isNextDisabled', this.isNextDisabled);

      if (step > 0) {
        if (this.step === 0 && !this.hasAdditionalQs) this.step += 1;
        if (this.step === 1 && !this.hasSubProducts) this.step += 1;

        if (this.step === 2 && !this.hasSaleableItems) this.step += 1;
      }
      if (step < 0) {
        if (this.step === 3 && !this.hasSubProducts) this.step -= 1;
        if (this.step === 2 && !this.hasAdditionalQs) this.step -= 1;
      }

      if (this.step === 3 && step === 1) {
        this.$store.commit('loading', true, 'Preparing Your Membership...');
        // Final step - add to cart
        if (!this.isFamilyMS) {
          const pendingRequiredRegos = this.$store.getters['cart/pendingRequiredRegos'];
          console.log('pendingRequiredRegos', pendingRequiredRegos);
          console.log('this.registration.product', this.registration.product);

          const pendingRequiredRego = pendingRequiredRegos.find((pendingRego) => {
            if (pendingRego && pendingRego._id) {
              console.log('pendingRego', pendingRego);
              const findRequiredId = pendingRego.products[0].membershipProductsRequired.find(
                (m) => {
                  if (Array.isArray(m)) {
                    return m[1] === this.registration.product._id;
                  }
                  return m.products?._id === this.registration.product?._id;
                }
              );
              return !!findRequiredId;
            }
            return false;
          });
          console.log('pendingRequiredRegoFound', pendingRequiredRego);
          // we need to check if the current product is requireApproval, if it is,we don't need to check the pendingRequiredRego
          console.log('this.registration.product', this.registration);
          if (this.registration.requiresApproval && !this.registration.newMembersOnly) {
            // If current registration requires approval, clear pending registrations and don't ask user
            this.isRequiredRego = false;
            this.pendingRequiredRego = undefined;
            this.$store.commit('cart/clearPendingRequiredRegos', pendingRequiredRego);
          } else if (!pendingRequiredRego) {
            // No pending registrations to process
            this.isRequiredRego = false;
            this.pendingRequiredRego = undefined;
          } else if (pendingRequiredRego) {
            // Has pending registrations, ask user if they want to register
            this.isRequiredRego = true;
            this.pendingRequiredRego = pendingRequiredRego;
          } else {
            // Has pending registrations but none match current registration
            this.isRequiredRego = false;
            this.pendingRequiredRego = undefined;
          }

          if (this.isRequiredRego) {
            this.$confirm(`Do you wish to also register to the product ${pendingRequiredRego.name}?`, 'Confirm', {
              distinguishCancelAndClose: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
            }).then(async () => {
              if (pendingRequiredRego && pendingRequiredRego.productType === 'indv-to-team' && (!pendingRequiredRego.selectedTeam && !pendingRequiredRego.team?.name)) {
                this.$message.error('You did not select a team to register. Please return to search and select a team.');
                throw new Error('You did not select a team to register. Please return to search and select a team.');
              }
              const rego = _.cloneDeep(this.registration);
              console.log('editing', this.editing);
              if (this.editing) this.$store.commit('cart/edit', rego);
              else {
                rego.isRequiredRego = true;
                [rego.requiredForProduct] = pendingRequiredRego.products;
                this.$store.commit('cart/add', rego);
              }
              this.$store.commit('cart/clearPendingRequiredRegos', pendingRequiredRego);
              // const selectedMember = this.$store.getters['user/selectedMember'];
              await this.startRegistration(pendingRequiredRego);
            }).catch(() => {
              _.assign(this.registration, { upgradeFromMembership: this.upgradeFromMembership });
              this.$store.commit('loading', { loading: true, text: 'Adding Registration To Cart...' });
              this.createMsCard();
              const presignedFileName = `membership-card-${this.registration.memberId}-${this.registration.entityId}-${this.registration.product._id}.png`;
              _.assign(this.registration, { membershipCard: presignedFileName });
              console.log('editing', this.editing);
              if (this.editing) this.$store.commit('cart/edit', this.registration);
              else {
                this.$store.commit('cart/add', this.registration);
              }
              this.$store.commit('loading', { loading: false });
              const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
              this.$router.push({ name: pathName, params: { isNewProduct: true } });
            });
          } else {
            if (_.get(this.registration, 'product.customFees.required') && _.get(this.registration, 'product.customFees.isFixedValue') === false && _.get(this.registration, 'product.customFees.value') === 0) {
              try {
                // eslint-disable-next-line no-await-in-loop
                await this.$confirm(`Would you like to contribute for ${_.get(this.registration, 'product.name', '') !== '' ? this.registration.product.name : this.registration.entityName}`, `${this.registration.product.customFees.label}`, {
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                  type: 'warning'
                });

                // eslint-disable-next-line no-await-in-loop
                const donationResponse = await this.$prompt('Please enter the amount you would like to contribute', `${this.registration.product.customFees.label}`, {
                  confirmButtonText: 'Confirm',
                  cancelButtonText: 'Cancel',
                  inputPattern: /\d+/,
                  inputErrorMessage: 'Please enter a valid number'
                });

                // eslint-disable-next-line no-param-reassign
                this.registration.product.customFees.value = parseInt(donationResponse.value) * 100;
              } catch (err) {
                console.log(err);
              }
            }
            this.$confirm('Do you want to perform another registration?', 'Confirm', {
              distinguishCancelAndClose: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
            }).then(async () => {
              _.assign(this.registration, { upgradeFromMembership: this.upgradeFromMembership });
              this.$store.commit('loading', { loading: true, text: 'Adding Registration To Cart...' });
              this.createMsCard();
              const presignedFileName = `membership-card-${this.registration.memberId}-${this.registration.entityId}-${this.registration.product._id}.png`;
              _.assign(this.registration, { membershipCard: presignedFileName });
              console.log('editing', this.editing);
              if (this.editing) this.$store.commit('cart/edit', this.registration);
              else {
                this.$store.commit('cart/add', this.registration);
              }
              this.$store.commit('loading', { loading: false });
              const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
              this.$router.push({ name: pathName });
            }).catch(async (action) => {
              if (action === 'cancel') {
                _.assign(this.registration, { upgradeFromMembership: this.upgradeFromMembership });
                this.$store.commit('loading', { loading: true, text: 'Adding Registration To Cart...' });
                this.createMsCard();
                const presignedFileName = `membership-card-${this.registration.memberId}-${this.registration.entityId}-${this.registration.product._id}.png`;
                _.assign(this.registration, { membershipCard: presignedFileName });
                console.log('editing', this.editing);
                if (this.editing) this.$store.commit('cart/edit', this.registration);
                else {
                  this.$store.commit('cart/add', this.registration);
                }
                this.$store.commit('loading', { loading: false });
                const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
                this.$router.push({ name: pathName, params: { isNewProduct: true } });
              }
            });
          }
        }

        this.$store.commit('loading', false);
      } else this.step += step;
    },
    async startRegistration(rego) {
      console.log('start registration', _.cloneDeep(rego));
      this.selectedRego = rego;
      if (rego.productType === 'indv-to-team' && rego.teams && (!rego.selectedTeam && !rego.team)) { return this.$message.error('Select a team to register.'); }
      if (rego.productType === 'entity' && !rego.selectedEntity) {
        return this.$message.error('Select an entity level to register.');
      }
      if (this.selectedRego.productType === 'entity') {
        const pathName = this.hasCustomEntity ? 'custom-membership-register-entity' : 'membership-register-entity';
        this.$router.push({
          name: pathName,
          params: { criteria: this.criteria, selectedMembership: this.selectedRego },
        });
      } else if (this.selectedRego.productType === 'team') {
        const pathName = this.hasCustomEntity ? 'custom-event-register-team' : 'event-register-team';
        this.$router.push({
          name: pathName,
          params: { criteria: this.criteria, selectedEvent: this.selectedRego },
        });
      } else if (this.memberId && _.get(this.member, 'profile.dob')) {
        console.log('this.member', this.member);
        // if user selected member in dashboard to register
        const endOfYear = this.$store.getters['national/endOfYear'];
        const age = calculateMemberAge(this.member.profile.dob, endOfYear);
        // const validProduct = _.find(rego.products, (p) => age >= p.ageFrom && age <= p.ageTo && (p.gender === this.member.profile.gender || p.gender === 'All'));
        // check if member is eligible to register
        // check if age is in range
        const product = rego.products[0];
        const validAge = product.ageFrom <= age && product.ageTo >= age;
        if (!validAge) {
          return this.$message.error('Unfortunately the member you selected doesn\'t meet the Age range registration criteria');
        }
        const validGender = product.gender === this.member.profile.gender || product.gender === 'All' || (product.gender === 'Other' && (this.member.profile.gender !== 'Male' || this.member.profile.gender !== 'Female'));

        if (!validGender) {
          return this.$message.error('Unfortunately the member you selected doesn\'t meet the Gender registration criteria');
        }
        // if (!validProduct) {
        //   console.log('validProduct', validProduct);
        //   return this.$message.error('Unfortunately the member you selected doesn\'t meet the registration criteria');
        // }

        if (rego.products.find((p) => p.isAccreditationRequired)) {
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          // this.$store.commit('loadingText', 'Loading...');
          const accreditationIds = _.map(_.get(rego, 'products[0].accreditationProductsRequired', []), (a) => a._id);
          const outerThis = this;
          this.$http.post('/assemble/api/v1/portal/registrations/member-accreditations', { accreditationIds }) // eslint-disable-next-line
            .then((res) => {
              this.$store.commit('loading', false);
              const accredMemberIds = res.data.data;
              if (!_.includes(accredMemberIds, outerThis.memberId)) return outerThis.$message.error('Accreditation is required to join this event');
              outerThis.selectMember(this.memberId);
            }).catch((e) => {
              this.$message.error(e.response.data.message);
              this.$store.commit('loading', false);
            });
        } else this.selectMember(this.memberId);
      } else {
        console.log('this.member', this.member);
        this.selectMemberModalVisible = true;
      }
      return true;
    },
    async selectMember(memberId) {
      console.log('selectMember', memberId);
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      // this.$store.commit('loadingText', 'Loading...');
      this.memberID = memberId;
      // Verify if eventId, memberId and memberType exists
      const registrations = this.$store.getters['cart/registrations'];

      if (this.selectedRego.registrationType === 'event') {
        const {
          _id: entityId, productType, memberType, tags, ageFrom, ageTo
        } = this.selectedRego;

        const foundRego = _.find(registrations, (r) => r.entityId === entityId
                                && r.memberId === memberId
                                && r.productType === productType
                                && r.ageFrom === ageFrom
                                && r.ageTo === ageTo
                                && r.memberType === memberType
                                && _.isEqual(r.tags, tags));
        if (foundRego && productType !== 'indv-to-team') {
          this.$store.commit('loading', false);
          return this.$message.error('Registration for this member has already been added to cart.');
        }

        if (foundRego && productType === 'indv-to-team') {
          const currentTeamId = this.selectedRego.selectedTeam;
          const foundTeam = _.find(registrations, (t) => t.team && t.team._id === currentTeamId);
          if (foundTeam) {
            this.$store.commit('loading', false);
            return this.$message.error('Registration for this member has already been added to cart.');
          }
        }

        if (this.selectedRego.productType === 'indv') {
          this.$store.commit('loading', false);
          const pathName = this.hasCustomEntity ? 'custom-event-register-individual' : 'event-register-individual';
          this.$router.push({
            name: pathName,
            params: { criteria: this.criteria, memberId, selectedEvent: this.selectedRego },
          });
        } else if (this.selectedRego.productType === 'indv-to-team') {
          if (this.selectedRego.teams) {
            const team = this.selectedRego.teams.find((item) => item._id === this.selectedRego.selectedTeam);
            if (!this.selectedRego.team) {
              _.assign(this.selectedRego, { team });
            }
            delete this.selectedRego.teams;
            delete this.selectedRego.selectedTeam;
          }
          this.$store.commit('loading', false);
          const pathName = this.hasCustomEntity ? 'custom-event-register-individual-to-team' : 'event-register-individual-to-team';
          this.$router.push({
            name: pathName,
            params: { criteria: this.criteria, memberId, selectedEvent: this.selectedRego },
          });
        } else {
          this.$store.commit('loading', false);
          this.$message.error('Registration for this product type is not available yet.');
        }
      } else if (this.selectedRego.registrationType === 'membership') {
        const {
          _id: entityId, productType, memberType, tags, ageFrom, ageTo
        } = this.selectedRego;

        const foundRego = _.find(registrations, (r) => r.entityId === entityId
                                && r.memberId === memberId
                                && r.productType === productType
                                && r.ageFrom === ageFrom
                                && r.ageTo === ageTo
                                && _.isEqual(r.tags, tags)
                                && r.memberType === memberType);
        if (foundRego) {
          this.$store.commit('loading', false);
          return this.$message.error('Registration for this member has already been added to cart.');
        }

        // check if member register to club membership before
        this.$store.commit('loading', { loading: true, text: 'Loading...' });
        // this.$store.commit('loadingText', 'Loading...');
        // if (!this.currentMemberMemberships) {
        //   const response = await this.getMemberMembership(memberId);
        //   this.memberMembership = response.data.data;
        //   this.$store.commit('user/setMemberRegos', this.memberMembership);
        // }
        this.$store.commit('loading', false);
        _.assign(this.selectedMembership, this.selectedRego);
        this.step = 0;
        // this.$forceUpdate();
        console.log('here ms');
      }
      return 0;
    },
    // Function to split text into lines based on the maximum width
    splitTextIntoLines(ctx, text, maxWidth) {
      const words = text.split(' ');
      const lines = [];
      let currentLine = words[0];

      for (let i = 1; i < words.length; i++) {
        const word = words[i];
        const { width } = ctx.measureText(`${currentLine} ${word}`);

        if (width < maxWidth) {
          currentLine += ` ${word}`;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      }

      lines.push(currentLine);
      return lines;
    },
    async createMsCard() {
      const currMember = this.$store.getters['user/selectedMember'];
      const currentSeason = this.$store.getters['national/currentSeason'];
      const currMemberProfilePic = _.get(currMember, 'meta.imgUrl');
      const entityPic = _.get(this.registration, 'logoUrl');
      const { orgtree } = this.registration;
      const memberMembership = this.$store.getters['user/getActiveMemberRegos'];
      let expectedExpiryDate;
      if (this.registration.renewFrom) {
        const renewalRego = _.find(memberMembership, (r) => r._id === this.registration.renewFrom);
        if (renewalRego) {
          expectedExpiryDate = renewalRego.expiry;
        }
      }
      // Manually create an array in the desired order from lowest to highest
      const orderedOrgtree = [
        orgtree.club, // Start with the lowest level
        orgtree.association,
        orgtree.state,
        orgtree.national
      ].filter((org) => org !== undefined); // This will remove any undefined levels, in case some levels do not exist

      const entityCreatedFirstLevel = orderedOrgtree[0] ? orderedOrgtree[0].name : '';
      const entityCreatedSecondLevel = orderedOrgtree[1] ? orderedOrgtree[1].name : '';
      // console.log('entityCreated length', entityCreated.length);
      const entityCreatedFirstLevelLimited = entityCreatedFirstLevel.length > 67 ? `${entityCreatedFirstLevel.substring(0, 67)}...` : entityCreatedFirstLevel;
      const entityCreatedSecondLevelLimited = entityCreatedSecondLevel.length > 77 ? `${entityCreatedSecondLevel.substring(0, 77)}...` : entityCreatedSecondLevel;

      // Reverse the array to start from club and then move up, and take the first two entities
      // const entityCreated = orderedOrgtree.slice(0, 2).map((org) => org.name).join(', ');
      // console.log('entityCreated length', entityCreated.length);
      // const entityCreatedLimited = entityCreated.length > 45 ? `${entityCreated.substring(0, 45)}...` : entityCreated;
      const getExpiryDate = () => {
        if (this.registration.useDuration) {
          if (expectedExpiryDate) {
            // add duration to expected expiry date
            return moment(expectedExpiryDate)
              .add(this.registration.durationYear, 'year')
              .add(this.registration.durationMonth, 'month')
              .add(this.registration.durationDay, 'day')
              .valueOf();
          }
          return moment()
            .add(this.registration.durationYear, 'year')
            .add(this.registration.durationMonth, 'month')
            .add(this.registration.durationDay, 'day')
            .valueOf();
        }
        return _.get(this.registration, 'endDate') || _.get(this.registration, 'expiry');
      };
      const membershipDetails = {
        membershipName: this.registration.entityName,
        membershipId: this.registration.entityId,
        expiry: getExpiryDate(),
        memberType: this.registration.memberType,
        season: currentSeason,
        memberId: this.registration.memberId,
        memberName: `${currMember.profile.firstName} ${currMember.profile.lastName}`,
        memberDob: currMember.profile.dob,
        memberNumber: _.get(currMember, 'meta.memberNumber', ''),
        entityCreatedFirstLevelLimited,
        entityCreatedSecondLevelLimited,
      };
      console.log('membershipDetails', membershipDetails);
      console.log('currMemberProfilePic', currMemberProfilePic);
      this.$store.commit('loading', true);
      const card = await this.generateMSCard(membershipDetails, currMemberProfilePic, entityPic);
      console.log('card', card);
      // get presigned url
      const presignedUrl = await this.$http.post('/assemble/api/v1/portal/membership-card/presigned-url', { fileName: `membership-card-${this.registration.memberId}-${this.registration.entityId}-${this.registration.product._id}.png` });
      console.log('presignedUrl', presignedUrl);
      const { url, s3Path } = presignedUrl.data.data;
      this.$store.commit('loading', false);

      if (s3Path) {
        _.assign(this.registration, { membershipCard: s3Path });
      }

      await fetch(url, {
        method: 'PUT',
        body: card,
        headers: { 'Content-Type': '*/*' },
      });
    },
    async getMemberMembership(memberId) {
      const response = await this.$http.get(`/assemble/api/v1/portal/registrations/members/${memberId}`);
      return response;
    },

    async generateMSCard(membershipDetails, memberProfilePics, entityPic) {
      const cardCanvas = document.createElement('canvas');
      cardCanvas.width = 500;
      cardCanvas.height = 300;
      const cardWidth = cardCanvas.width;
      const pageHeight = cardCanvas.height;
      const cardContext = cardCanvas.getContext('2d');
      const lineSpacing = 22;
      const columnSpacing = 260;
      const lineWidth = 2;
      let isLogoURL = false;
      let isProfileURL = false;
      let isEntityURL = false;

      let logoImage;
      let profileImage;
      let entityImage;
      let logoPromise; let profilePromise; let
        entityPromise;

      console.log('membersProfile', memberProfilePics);

      // Load Logo Image
      if (process.env.VUE_APP_LOGO && process.env.VUE_APP_LOGO !== '') {
        isLogoURL = true;
      }
      if (memberProfilePics && memberProfilePics !== '') {
        isProfileURL = true;
      }
      if (entityPic && entityPic !== '') {
        isEntityURL = true;
      }
      if (isLogoURL) {
        const logoContent = await this.$http.post('/assemble/api/v1/portal/registrations/image-content', { logo: process.env.VUE_APP_LOGO, isURL: true });
        logoImage = new Image();
        logoImage.src = logoContent.data.data.imageContent;
        // eslint-disable-next-line no-return-assign
        logoPromise = new Promise((resolve) => logoImage.onload = resolve);
      }
      if (isProfileURL) {
        console.log('profile', memberProfilePics);
        const profileContent = await this.$http.post('/assemble/api/v1/portal/registrations/image-content', { memberProfile: memberProfilePics, isURL: true });
        profileImage = new Image();
        profileImage.src = profileContent.data.data.memberImageContent;
        // eslint-disable-next-line no-return-assign
        profilePromise = new Promise((resolve) => profileImage.onload = resolve);
      }
      if (isEntityURL) {
        console.log('entity', entityPic);
        const entityContent = await this.$http.post('/assemble/api/v1/portal/registrations/image-content', { entityLogo: entityPic, isURL: true });
        entityImage = new Image();
        entityImage.src = entityContent.data.data.entityImageContent;
        // eslint-disable-next-line no-return-assign
        entityPromise = new Promise((resolve) => entityImage.onload = resolve);
      }

      await Promise.all([logoPromise, profilePromise, entityPromise]);

      // eslint-disable-next-line no-return-assign, no-param-reassign
      // await Promise.all([logoImage, memberProfilePics, entityPic].map((image) => new Promise((resolve) => image.onload = resolve)));

      // Draw the card background with border radius on the canvas
      cardContext.fillStyle = '#fff';
      cardContext.beginPath();
      cardContext.moveTo(20, 0);
      cardContext.lineTo(cardWidth - 20, 0);
      cardContext.quadraticCurveTo(cardWidth, 0, cardWidth, 20);
      cardContext.lineTo(cardWidth, pageHeight - 20);
      cardContext.quadraticCurveTo(cardWidth, pageHeight, cardWidth - 20, pageHeight);
      cardContext.lineTo(20, pageHeight);
      cardContext.quadraticCurveTo(0, pageHeight, 0, pageHeight - 20);
      cardContext.lineTo(0, 20);
      cardContext.quadraticCurveTo(0, 0, 20, 0);
      cardContext.closePath();
      cardContext.fill();

      // Draw the card border
      // Add border to the card
      cardContext.lineWidth = 2; // Set the border thickness
      cardContext.strokeStyle = '#000'; // Set the border color
      cardContext.stroke(); // Draw the border

      // Draw member profile logo on the top left
      const profileLogoWidth = 100;
      const profileLogoHeight = 100;
      const profileLogoX = 10;
      const profileLogoY = 10;
      cardContext.globalAlpha = 1;
      if (profileImage) {
        cardContext.drawImage(profileImage, profileLogoX, profileLogoY, profileLogoWidth, profileLogoHeight);
      } else {
        cardContext.fillStyle = '#888';
        cardContext.fillRect(profileLogoX, profileLogoY, profileLogoWidth, profileLogoHeight);
      }

      // Draw entity logo on the top right
      const entityLogoWidth = 100;
      const entityLogoHeight = 100;
      const entityLogoX = cardWidth - entityLogoWidth - 10;
      const entityLogoY = 10;

      if (entityImage) {
        cardContext.drawImage(entityImage, entityLogoX, entityLogoY, entityLogoWidth, entityLogoHeight);
      } else {
        cardContext.drawImage(logoImage, entityLogoX, entityLogoY, entityLogoWidth, entityLogoHeight);
      }

      const maxLineWidth = 260; // Maximum line width in pixels for the first level text

      // Draw entity created first level limited and second level limited in the top middle
      // First level with h2-like font size and black color
      cardContext.font = 'bold 22px BrownStd-Regular';
      cardContext.fillStyle = '#000'; // Black color
      // Adjust the starting Y position for the text to be closer to the top, with a small margin
      const textStartX = profileLogoX + profileLogoWidth + 10; // Start text from the right edge of the profile photo with a 10px margin
      const entityTextY = profileLogoY + 20; // Start text 10px below the top edge of the profile logo

      // Use the splitTextIntoLines function to handle potentially long text for the first level
      const firstLevelLines = this.splitTextIntoLines(cardContext, membershipDetails.entityCreatedFirstLevelLimited, maxLineWidth);
      firstLevelLines.slice(0, 2).forEach((line, index) => { // Ensure only up to 2 lines are drawn for the first level
        cardContext.fillText(line, textStartX, entityTextY + (index * 25));
      });

      // Calculate Y position for second level based on how many lines were used for first level
      const secondLevelStartY = entityTextY + (firstLevelLines.length * 25) + 5; // Adjust Y position as needed for second line, with some spacing

      // Draw entity created second level limited in gray color and normal font size, potentially split into 2 lines
      cardContext.font = '16px BrownStd-Regular'; // Normal size for second level
      cardContext.fillStyle = '#888'; // Gray color for second level

      // Use the splitTextIntoLines function for the second level as well
      const secondLevelLines = this.splitTextIntoLines(cardContext, membershipDetails.entityCreatedSecondLevelLimited, maxLineWidth);
      secondLevelLines.slice(0, 2).forEach((line, index) => { // Ensure only up to 2 lines are drawn for the second level
        cardContext.fillText(line, textStartX, secondLevelStartY + (index * 20));
      });

      // Draw membership details at the bottom
      cardContext.fillStyle = '#000';
      cardContext.font = 'bold 22px BrownStd-Regular';
      const membershipNameLines = this.splitTextIntoLines(cardContext, `${membershipDetails.membershipName}`, 450);
      membershipNameLines.forEach((line, index) => {
        cardContext.fillText(line, 10, pageHeight - 150 + index * lineSpacing);
      });

      // a line to display entity name
      // cardContext.font = '16px BrownStd-Regular';
      // cardContext.fillStyle = '#888';
      // cardContext.fillText(`${membershipDetails.entity}`, 10, pageHeight - 150 + 1 * lineSpacing); // Adjust the vertical position as needed

      // first column
      cardContext.font = '18px BrownStd-Regular';
      // membership details label, gray text color
      cardContext.fillStyle = '#aaa';
      cardContext.fillText('Membership Details', 10, pageHeight - 150 + 2 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillStyle = '#000';
      cardContext.font = '16px BrownStd-Regular';
      // cardContext.fillText(`Entity: ${membershipDetails.entity}`, 10, pageHeight - 150 + 3 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillText(`Member Type: ${membershipDetails.memberType}`, 10, pageHeight - 150 + 3 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillText(`Season: ${membershipDetails.season}`, 10, pageHeight - 150 + 4 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillText(`${membershipDetails.expiry ? `Exp: ${this.msDateFormatter(membershipDetails.expiry)}` : ''}`, 10, pageHeight - 150 + 5 * lineSpacing); // Adjust the vertical position as needed

      // Draw vertical line between columns
      cardContext.beginPath();
      cardContext.moveTo(columnSpacing - 20, pageHeight - 150 + 2 * lineSpacing);
      cardContext.lineTo(columnSpacing - 20, pageHeight - 150 + 6 * lineSpacing);
      cardContext.lineWidth = lineWidth;
      cardContext.strokeStyle = '#888';
      cardContext.stroke();

      // second column
      cardContext.font = '18px BrownStd-Regular';
      // membership details label, gray text color
      cardContext.fillStyle = '#aaa';
      cardContext.fillText('Member Details ', columnSpacing, pageHeight - 150 + 2 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillStyle = '#000';
      cardContext.font = '16px BrownStd-Regular';
      cardContext.fillText(`Name: ${membershipDetails.memberName}`, columnSpacing, pageHeight - 150 + 3 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillText(`Member ID: ${membershipDetails.memberId}`, columnSpacing, pageHeight - 150 + 4 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillText(`Member Number: ${membershipDetails.memberNumber}`, columnSpacing, pageHeight - 150 + 5 * lineSpacing); // Adjust the vertical position as needed
      const dobFormat = +process.env.VUE_APP_NATIONAL_ID === 15 ? 'YYYY' : 'DD/MM/YYYY';
      cardContext.fillText(`DOB: ${moment(membershipDetails.memberDob).format(dobFormat)}`, columnSpacing, pageHeight - 150 + 6 * lineSpacing); // Adjust the vertical position as needed

      // Reset alpha for the entity logo
      // Draw card watermark (background image)
      cardContext.globalAlpha = 0.1;
      cardContext.drawImage(logoImage, 0, 0, cardWidth, pageHeight);
      cardContext.globalAlpha = 1;

      // create a new image object
      return new Promise((resolve) => {
        cardCanvas.toBlob((blob) => {
          resolve(blob);
        }, 'image/png');
      });
    },
    msDateFormatter(timestamp) {
      // return in this type mm/yyyy
      return moment(timestamp).tz(this.timezone).format('DD/MM/YYYY');
    },
    cancel() {
      const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
      this.$router.push({ name: pathName, params: { defaultCriteria: this.criteria } });
    },
    back() {
      if (this.step === 0) {
        console.log('pendingRegistration', this.pendingRegistration);
        // push with query params
        const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
        this.$router.push({
          name: pathName,
          params: { pendingRegistration: this.pendingRegistration, defaultCriteria: this.criteria },
        });
      } else this.$refs.rego.updateStep(-1);
    },
    next() {
      if ((this.selectedMembership && this.selectedMembership.productType === 'family') || (this.editingRego && this.editingRego.productType === 'family')) {
        this.familyFinalNext();
      } else this.$refs.rego.updateStep(1);
    },
    updateFamilyMs(registration) {
      _.assign(registration, { upgradeFromMembership: this.upgradeFromMembership });
      this.familyRegistrations.push(registration);
    },
    validateFamilyDetail(result) {
      this.familyRef.push(result);
    },
    familyFinalNext() {
      _.forEach((this.$refs.familyRef), (regoRef) => {
        regoRef.updateStep(1);
      });

      const allValid = _.every(this.familyRef, (form) => form === true);
      if (!this.editing) {
        const {
          _id,
          name,
          registrationType,
          productType,
          memberType,
          products,
          productId,
          acceptActiveKids,
          isClubMembership,
          tags,
          multipleRegoDiscounts,
          multipleSaleableItemDiscounts,
          startDate,
          endDate,
        } = this.selectedMembership;

        const familyObj = {
          entityName: name,
          entityType: registrationType,
          entityId: _id,
          productType,
          memberType,
          isClubMembership: isClubMembership || false,
          tags,
          acceptActiveKids,
          multipleRegoDiscounts,
          multipleSaleableItemDiscounts,
          startDate,
          endDate,
          productId,
          product: products[0],
          familyRegistrations: this.familyRegistrations
        };

        if (allValid) {
          this.$confirm('Do you want to perform another registration?', 'Confirm', {
            distinguishCancelAndClose: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
          }).then(() => {
            this.$store.commit('cart/add', familyObj);
            const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
            this.$router.push({ name: pathName });
          }).catch((action) => {
            if (action === 'cancel') {
              this.$store.commit('cart/add', familyObj);
              const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
              this.$router.push({ name: pathName });
            }
          });
        } else {
          this.familyRef = [];
        }
      } else if (this.editing) {
        this.$store.commit('cart/edit', this.editingRego);
        const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
        this.$router.push({ name: pathName, params: { isNewProduct: true } });
      }
    }

  },
  computed: {
    ...mapGetters('cart', ['pendingRegistration']),
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    hasAdditionalQs() {
      console.log('this.registration at hasAdditionalQs', this.registration);
      if (!this.registration.isRenewable && !this.registration.isRenewingProduct) {
        return this.registration.additionalQs && this.registration.additionalQs.length;
      }
      // if renewalAdditionalQs is not set, and isRenewable is true, return false
      if (!this.registration.renewalAdditionalQs && this.registration.isRenewable && this.registration.isRenewingProduct) {
        return false;
      }
      const additionalQsIsFromManagement = _.filter(this.registration.additionalQs, (q) => q.isFromManagement);
      return (this.registration.renewalAdditionalQs && this.registration.additionalQs && this.registration.additionalQs.length) || (additionalQsIsFromManagement && additionalQsIsFromManagement.length);
    },
    hasSaleableItems() {
      if (!this.registration.isRenewable) {
        return this.registration.saleableItems && this.registration.saleableItems.length;
      }
      if (!this.registration.renewalSaleableItems && this.registration.isRenewable) {
        return false;
      }
      return this.registration.renewalSaleableItems && this.registration.saleableItems && this.registration.saleableItems.length;
    },
    msProductType() {
      return _.get(this, 'selectedMembership.productType') || this.editingRego.productType;
    },
    isFamilyMS() {
      return _.get(this, 'selectedMembership.productType') === 'family';
    },
    timezone() {
      return this.$store.getters['national/timezone'];
    },
    hasSubProducts() {
      return this.registration && this.registration.product && this.registration.product.hasSubProducts && this.registration.product.subProducts && this.registration.product.subProducts.length;
    }
  }
};
</script>

<style scoped lang="scss">
.main-content {
  width: 90%;
  max-width: $md;

  // .content-body {
  //   width: 100%;
  // }

  .bottomBtn {
    max-width: 100%;
    width: 12em;
  }

  .disabled-next {
    background: rgba($highlight, 0.7);
    border: 0 !important;
    cursor: pointer !important;
  }
}
</style>
